export var Format;
(function (Format) {
    Format["HTML"] = "html";
    Format["PLAIN"] = "plain";
})(Format || (Format = {}));
var KnownSectionKey;
(function (KnownSectionKey) {
    KnownSectionKey["TORAH"] = "torah";
    KnownSectionKey["NEVIIM"] = "neviim";
})(KnownSectionKey || (KnownSectionKey = {}));
export function toSingleSection(metadata, sectionKey) {
    return {
        section: metadata.sections[sectionKey],
        available_parsha: metadata.available_parsha,
        logged_in_user: metadata.logged_in_user,
    };
}
